// require('./bootstrap');

$(function () {
    $("#loading").fadeOut(500);
});

// import intlTelInput from "intl-tel-input";

// const input = document.querySelector("#phone-country");
// if (input) {
//     var iti = intlTelInput(input, {
//         initialCountry: "auto",
//         autoHideDialCode: true,
//         autoPlaceholder: "aggressive",
//         formatOnDisplay: true,
//         separateDialCode: true,
//         nationalMode: true,
//         preferredCountries: [
//             "pe",
//             "ve",
//             "mx",
//             "ar",
//             "co",
//             "cl",
//             "br",
//             "ec",
//             "rd",
//             "es",
//         ],
//         geoIpLookup: function (callback) {
//             $.get("https://ipinfo.io", function () { }, "jsonp").always(
//                 function (resp) {
//                     var countryCode =
//                         resp && resp.country ? resp.country : "pe";
//                     callback(countryCode);
//                 }
//             );
//         },
//         utilsScript: require("intl-tel-input/build/js/utils.js"),
//     });

//     input.addEventListener('blur', function () {
//         $('#phone_number').val(iti.getNumber());
//     });
// }

new WOW().init();

$("#searchStudent").keyup(function () {
    var search = $(this).val();
    $("#students > div").each(function () {
        let name = this.getAttribute("data-user-name");
        let email = this.getAttribute("data-user-email");
        let dni = this.getAttribute("data-user-dni");
        let data = name + email + dni;
        if (data.search(new RegExp(search, "i")) < 0) {
            $(this).hide();
        } else {
            $(this).show();
        }
    });
});

$("#searchList").keyup(function () {
    var search = $(this).val();
    $("#studentList > li").each(function () {
        if ($(this).text().search(new RegExp(search, "i")) < 0) {
            $(this).hide();
        } else {
            $(this).show();
        }
    });
});

$("#mobile-menu").meanmenu({
    meanMenuContainer: ".mobile-menu",
    meanScreenWidth: "1199",
    meanExpand: ['<i class="fal fa-plus"></i>'],
});

$("#sidebar-toggle").on("click", function () {
    $(".sidebar__area").addClass("sidebar-opened");
    $(".body-overlay").addClass("opened");
});

$(".sidebar__close-btn").on("click", function () {
    $(".sidebar__area").removeClass("sidebar-opened");
    $(".body-overlay").removeClass("opened");
});

$(".cart-toggle-btn").on("click", function () {
    $(".cartmini__wrapper").addClass("opened");
    $(".body-overlay").addClass("opened");
});

$(".cartmini__close-btn").on("click", function () {
    $(".cartmini__wrapper").removeClass("opened");
    $(".body-overlay").removeClass("opened");
});

$(window).on("scroll", function () {
    var scroll = $(window).scrollTop();
    if (scroll < 100) {
        $("#header-sticky").removeClass("sticky");
    } else {
        $("#header-sticky").addClass("sticky");
    }
});

var swiper = new Swiper(".testimonial__slider", {
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

var swiperTopbar = new Swiper(".swiper-topbar", {
    autoplay: {
        delay: 5000,
        disableOnInteraction: true,
    },
    loop: true,
});

var promotionsw = new Swiper(".promotions__slider", {
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    spaceBetween: 30,
    autoplay: true,
    loop: true,
});

var swiper = new Swiper(".swiper-teacher", {
    slidesPerView: 3,
    spaceBetween: 30,
    autoplay: {
        delay: 2500,
        disableOnInteraction: true,
    },
    breakpoints: {
        768: {
            slidesPerView: 3,
        },
        576: {
            slidesPerView: 1,
        },
        0: {
            slidesPerView: 1,
        },
    },
});

var galleryTop = new Swiper(".slider__wrapper", {
    spaceBetween: 0,
    effect: "fade",
    loop: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

var swiper = new Swiper(".brand__slider", {
    slidesPerView: 3,
    spaceBetween: 30,
    centeredSlides: true,
    loop: true,
    autoplay: {
        delay: 2500,
        disableOnInteraction: false,
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        768: {
            slidesPerView: 3,
        },
        576: {
            slidesPerView: 2,
        },
        0: {
            slidesPerView: 1,
        },
    },
});

var swiper = new Swiper(".partners_slider", {
    slidesPerView: 3,
    spaceBetween: 50,
    centeredSlides: true,
    loop: true,
    autoplay: {
        delay: 2500,
        disableOnInteraction: false,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        768: {
            slidesPerView: 3,
        },
        576: {
            slidesPerView: 2,
        },
        0: {
            slidesPerView: 1,
        },
    },
});

var swiper = new Swiper(".course__slider", {
    spaceBetween: 30,
    slidesPerView: 3,
    breakpoints: {
        768: {
            slidesPerView: 3,
        },
        576: {
            slidesPerView: 2,
        },
        0: {
            slidesPerView: 1,
        },
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
});

$(".grid").imagesLoaded(function () {
    var $grid = $(".grid").isotope({
        itemSelector: ".grid-item",
        percentPosition: true,
        masonry: {
            columnWidth: ".grid-item",
        },
    });
});

$("[data-background").each(function () {
    $(this).css(
        "background-image",
        "url( " + $(this).attr("data-background") + "  )"
    );
});

$("[data-width]").each(function () {
    $(this).css("width", $(this).attr("data-width"));
});

function readURL(input) {
    if (input.files && input.files[0]) {
        var reader = new FileReader();

        reader.onload = function (e) {
            $("#preview").attr("src", e.target.result);
        };
        reader.readAsDataURL(input.files[0]);
    }
}

$(function () {
    $("#profile-upload").change(function () {
        readURL(this);
    });
});

$.fn.customStarRatings = function (obj) {
    var wrapper = this;
    var stars = obj.childClass;
    var input = obj.inputClass;
    let activeClassCount;
    $(wrapper).hover(
        function () {
            activeClassCount = $(this).find(".rating-score").index() + 1;
        },
        function () {
            var $this = $(this);
            $this.find(stars).slice(1, activeClassCount).addClass("is-active");
            $this
                .find(stars)
                .slice(activeClassCount, 10)
                .not(".rating-score")
                .removeClass("is-active");
        }
    );
    $(stars).hover(function () {
        $(this).prevAll(stars).add($(this)).addClass("is-active");
        $(this).nextAll(stars).removeClass("is-active");
    });
    $(stars).click(function (event) {
        $(".rating-score").removeClass("rating-score");
        $(this).addClass("rating-score");
        activeClassCount = $(this).index() + 1;
        $(this).prevAll(stars).addClass("is-active");
        if (input) {
            $(input).val(($(this).index() + 1) / 2);
            // console.log($(input).val(), activeClassCount);
        }
    });
};

$(".rating").customStarRatings({
    childClass: ".rating__item",
    inputClass: "#rating",
});

$(document).ready(function () {
    $("a#preview").fancybox();
});

$("#courseTab").on("click", function () {
    $("#courseTab button").each(function () {
        if ($(this).hasClass("active")) {
            let open = $(this).prop("data-content-open");
            if (open) {
                var parentId = $(this).attr("data-bs-target");
                if ($(parentId).hasClass("active")) {
                    $(parentId).removeClass("active");
                    $(this).removeClass("active");
                }
                $(this).prop("data-content-open", false);
            } else {
                $(this).prop("data-content-open", true);
            }
        } else {
            $(this).prop("data-content-open", false);
        }
    });
});
